/**
 * @param {type} 长车路由
 * @return:
 */
import colorFormTrimStore from "@/views/main/colorTrim/form.js";
import blendcolorFormTrimStore from "@/views/main/blendColorTrim/form.js";
export default [
  // 打样工作台
  // 下发
  {
    path: "/issueTable",
    meta: { alias: "/order-proofingSystems" },
    component: () =>
      import(
        /* @vite-ignore */ "../views/main/indent/proofingSystems/index.vue"
      ),
    children: [
      // 小样下发
      {
        path: "",
        meta: { alias: "/order-issueTable" },
        component: () =>
          import(
            /* @vite-ignore */ "../views/main/indent/proofingSystems/issueTable/index.vue"
          ),
      },
      // 复样下发
      {
        path: "duplicateTable",
        meta: {
          alias: "/order-duplicateTable",
          parentRouter: "/issueTable",
        },
        component: () =>
          import(
            /* @vite-ignore */ "../views/main/indent/proofingSystems/duplicateTable/index.vue"
          ),
      },
    ],
  },
  // 打样工作台 -- 配色
  {
    path: "/dColorMatch",
    meta: { alias: "/order-dColorMatch", parentRouter: "/issueTable" },
    component: () =>
      import(
        /* @vite-ignore */ "../views/main/indent/proofingSystems/colorMatch/index.vue"
      ),
    beforeEnter: (to, from) => {
      if (
        !["/dColorMatchRes", "/"].includes(from.path) ||
        to.path != "/dColorMatch"
      ) {
        localStorage.removeItem("proofingSystems");
      }
    },
  },
  // 打样工作台 -- 配色结果
  {
    path: "/dColorMatchRes",
    meta: { alias: "/order-dColorMatchRes", parentRouter: "/issueTable" },
    component: () =>
      import(
        /* @vite-ignore */ "../views/main/indent/proofingSystems/colorMatch/tableRes.vue"
      ),
  },
  // 打样工作台 -- 复样配色
  {
    path: "/dBlendColorMatch",
    meta: {
      alias: "/order-dBlendColorMatch",
      parentRouter: "/issueTable",
    },
    component: () =>
      import(
        /* @vite-ignore */ "../views/main/indent/proofingSystems/BlendColorMatch/index.vue"
      ),
    beforeEnter: (to, from) => {
      if (
        !["/dBlendColorMatchRes", "/"].includes(from.path) ||
        to.path != "/dBlendColorMatch"
      ) {
        sessionStorage.removeItem("BlendProofingSystems");
      }
    },
  },
  // 打样工作台 -- 复样配色结果
  {
    path: "/dBlendColorMatchRes",
    meta: {
      alias: "/order-dBlendColorMatchRes",
      parentRouter: "/issueTable",
    },
    component: () =>
      import(
        /* @vite-ignore */ "../views/main/indent/proofingSystems/BlendColorMatch/tableRes.vue"
      ),
  },
  // 打样工作台 -- 记录
  {
    path: "/dRecord",
    meta: { alias: "/order-dRecord", parentRouter: "/issueTable" },
    component: () =>
      import(
        /* @vite-ignore */ "../views/main/indent/proofingSystems/record/index.vue"
      ),
  },
  // 打样工作台 员工操作
  {
    path: "/workbench",
    meta: { alias: "/order-workbench" },
    component: () =>
      import(
        /* @vite-ignore */ "../views/main/indent/proofingSystems/workbench/index.vue"
      ),
    children: [
      // 小样下发
      {
        path: "",
        meta: { alias: "/order-WissueTable" },
        component: () =>
          import(
            /* @vite-ignore */ "../views/main/indent/proofingSystems/workbench/mainPage.vue"
          ),
      },
      // 复样下发
      {
        path: "WduplicateTable",
        meta: {
          alias: "/order-WduplicateTable",
          parentRouter: "/workbench",
        },
        component: () =>
          import(
            /* @vite-ignore */ "../views/main/indent/proofingSystems/workbench/BmainPage.vue"
          ),
      },
    ],
  },
  // 打样工作台 员工操作 -- 配色
  {
    path: "/workbenchMatch",
    meta: { alias: "/order-workbenchMatch", parentRouter: "/workbench" },
    component: () =>
      import(
        /* @vite-ignore */ "../views/main/indent/proofingSystems/workbench/colorMatch.vue"
      ),
    beforeEnter: (to, from) => {
      if (
        !["/wColorMatchRes", "/"].includes(from.path) ||
        to.path != "/workbenchMatch"
      ) {
        localStorage.removeItem("workbenchColor");
      }
    },
  },
  // 打样工作台 员工操作 -- 配色结果
  {
    path: "/wColorMatchRes",
    meta: { alias: "/order-wColorMatchRes", parentRouter: "/workbench" },
    component: () =>
      import(
        /* @vite-ignore */ "../views/main/indent/proofingSystems/workbench/tableRes.vue"
      ),
  },
  // 打样工作台 员工操作 -- 混纺配色
  {
    path: "/workbenchBlendMatch",
    meta: {
      alias: "/order-workbenchBlendMatch",
      parentRouter: "/workbench",
    },
    component: () =>
      import(
        /* @vite-ignore */ "../views/main/indent/proofingSystems/workbench/BlendColorMatch.vue"
      ),
    beforeEnter: (to, from) => {
      if (
        !["/wBlendColorMatchRes", "/"].includes(from.path) ||
        to.path != "/workbenchBlendMatch"
      ) {
        sessionStorage.removeItem("workbenchBlendColor");
      }
    },
  },
  // 打样工作台 员工操作 -- 混纺配色结果
  {
    path: "/wBlendColorMatchRes",
    meta: {
      alias: "/order-wBlendColorMatchRes",
      parentRouter: "/workbench",
    },
    component: () =>
      import(
        /* @vite-ignore */ "../views/main/indent/proofingSystems/workbench/BlendTableRes.vue"
      ),
  },
  // 打样工作台 员工操作 修色
  {
    path: "/workbenchTrimForm",
    meta: {
      alias: "/order-workbenchTrimForm",
      parentRouter: "/workbench",
    },
    component: () =>
      import(/* @vite-ignore */ "../views/main/colorTrim/form.vue"),
    beforeEnter: (to, from) => {
      if (
        ![
          "/workbenchTrimFormResult",
          "/",
          "/workbenchTrimFormadjustment",
        ].includes(from.path) ||
        to.path != "/workbenchTrimForm"
      ) {
        sessionStorage.removeItem("_params");
        sessionStorage.removeItem("resultList");
        colorFormTrimStore.init();
      }
    },
  },
  // 打样工作台 员工操作 修色结果
  {
    path: "/workbenchTrimFormResult",
    meta: {
      parentRouter: "/workbench",
      alias: "/order-workbenchTrimFormResult",
    },
    component: () =>
      import(/* @vite-ignore */ "../views/main/colorTrim/formResult.vue"),
  },
  // 打样工作台 员工操作 微调结果
  {
    path: "/workbenchTrimFormadjustment",
    meta: {
      parentRouter: "/workbench",
      alias: "/order-workbenchTrimFormadjustment",
    },
    component: () =>
      import(/* @vite-ignore */ "../views/main/colorTrim/adjustment.vue"),
  },

  // 打样工作台 员工操作 混纺修色
  {
    path: "/workBlend-color-trim-form",
    meta: {
      parentRouter: "/workbench",
      alias: "/order-workBlend-color-trim-form",
    },
    component: () =>
      import(/* @vite-ignore */ "../views/main/blendColorTrim/indenTform.vue"),
    beforeEnter: (to, from) => {
      if (
        ![
          "/workBlend-color-trim-form-result",
          "/",
          "/workBlend-color-trim-form-adjustment-result",
        ].includes(from.path)
      ) {
        blendcolorFormTrimStore.init();
        sessionStorage.removeItem("colorTableListTrim");
      }
    },
  },
  // 打样工作台 员工操作 混纺修色结果
  {
    path: "/workBlend-color-trim-form-result",
    meta: {
      parentRouter: "/workbench",
      alias: "/order-workBlend-color-trim-form-result",
    },
    component: () =>
      import(/* @vite-ignore */ "../views/main/blendColorTrim/formResult.vue"),
  },
  // 打样工作台 员工操作 混纺修色微调结果
  {
    path: "/workBlend-color-trim-form-adjustment-result",
    meta: {
      parentRouter: "/workbench",
      alias: "/order-workBlend-color-trim-form-adjustment-result",
    },
    component: () =>
      import(/* @vite-ignore */ "../views/main/blendColorTrim/adjustment.vue"),
  },
  // 打样工作台 员工操作 混纺一浴修色
  {
    path: "/workBlend-color-oneBathProcess",
    meta: {
      parentRouter: "/workbench",
      alias: "/order-workBlend-color-oneBathProcess",
    },
    component: () =>
      import(
        /* @vite-ignore */ "../views/main/blendColorTrim/oneBathProcess/indenTform.vue"
      ),
    beforeEnter: (to, from) => {
      if (
        ![
          "/workBlend-color-oneBathProcess-result",
          "/",
          "/workBlend-oneBathProcess-adjustment-result",
        ].includes(from.path)
      ) {
        sessionStorage.removeItem("oneBathResult");
      }
    },
  },
  // 打样工作台 员工操作 混纺一浴法结果
  {
    path: "/workBlend-color-oneBathProcess-result",
    meta: {
      parentRouter: "/workbench",
      alias: "/order-workBlend-color-oneBathProcess-result",
    },
    component: () =>
      import(
        /* @vite-ignore */ "../views/main/blendColorTrim/oneBathProcess/result.vue"
      ),
  },
  // 打样工作台 员工操作 混纺一浴法微调结果
  {
    path: "/workBlend-oneBathProcess-adjustment-result",
    meta: {
      parentRouter: "/workbench",
      alias: "/order-workBlend-oneBathProcess-adjustment-result",
    },
    component: () =>
      import(/* @vite-ignore */ "../views/main/blendColorTrim/adjustment.vue"),
  },

  // 打样工作台 员工操作 -- ABC页面(小样)
  // 录入ABC样
  {
    path: "/workbenchBlendABC",
    meta: {
      alias: "/order-workbenchBlendABC",
      parentRouter: "/workbench",
    },
    component: () =>
      import(/* @vite-ignore */ "../views/main/indent/ABC/blendAbc.vue"),
  },
  // 录入ABC样 混纺
  {
    path: "/workbenchABC",
    meta: { alias: "/order-workbenchABC", parentRouter: "/workbench" },
    component: () =>
      import(/* @vite-ignore */ "../views/main/indent/ABC/index.vue"),
  },
  // 复样进入ABC页面
  {
    path: "/workbenchDABC",
    meta: { alias: "/order-workbenchDABC", parentRouter: "/workbench" },
    component: () =>
      import(/* @vite-ignore */ "../views/main/indent/ABC/dIndex.vue"),
  },
  // 混纺复样进入ABC页面
  {
    path: "/workbenchBlendDABC",
    meta: {
      alias: "/order-workbenchBlendDABC",
      parentRouter: "/workbench",
    },
    component: () =>
      import(/* @vite-ignore */ "../views/main/indent/ABC/dBlendAbc.vue"),
  },
  // 打样员管理
  {
    path: "/proofingPress",
    meta: { alias: "/order-proofingPress" },
    component: () =>
      import(/* @vite-ignore */ "../views/main/indent/proofingPress/index.vue"),
  },
  // 订单 --- 数据看板工作台(机械臂)
  {
    path: "/board",
    meta: { alias: "/order-board" },
    component: () =>
      import(/* @vite-ignore */ "../views/main/indent/board/index.vue"),
  },
  //订单 ---  滴液机列表 dripMachineList
  {
    path: "/dripMachineList",
    meta: { alias: "/order-dripMachineList", parentRouter: "/workbench" },
    component: () =>
      import(
        /* @vite-ignore */ "../views/main/indent/proofingSystems/workbench/dripMachineList.vue"
      ),
  },
];
